module.exports = __webpack_public_path__ + "static/media/076-microphone.fbbcc087.svg";